var EPK = EPK || {};
EPK.PharmacyInquiry = EPK.PharmacyInquiry || {};

/** #27605 */
EPK.PharmacyInquiry.ErrorFlags = {
	report_type:false,
	detail:false,
	mail:false,
	name:false,
	agree:false
};

EPK.PharmacyInquiry.checkValidation = function () {
	var form = document.forms[0];

	if (form) {
		var reportType = form['report_type'],
		detail = form['detail'],
		mail = form['mail'],
		name = form['name'],
		agree = form['agree'];
		if (reportType) {
			EPK.PharmacyInquiry.checkreportType(reportType);
		}

		if (detail) {
			EPK.PharmacyInquiry.checkdetail(detail);
		}

		if (mail) {
			EPK.PharmacyInquiry.checkMail(mail);
		}

		if (name) {
			EPK.PharmacyInquiry.checkName(name);
		}

		if (agree && agree.length > 0) {
			EPK.PharmacyInquiry.checkAgree(agree);
		}
	}
};

EPK.PharmacyInquiry.changeValidation = function () {
	var form = document.forms[0];

	function checkError() {
		var errorArry = [];
		var submitBtn;
		if (EPK.common.isSP) {
			submitBtn = document.querySelector('.terms .submit-button');
		} else {
			submitBtn = document.querySelector('.contact-form-submit-box .contact-form-submit');
		}
		Object.keys(EPK.PharmacyInquiry.ErrorFlags).forEach(function(key) {
			if (EPK.PharmacyInquiry.ErrorFlags[key]) {
				errorArry.push(EPK.PharmacyInquiry.ErrorFlags[key]);
				EPK.PharmacyInquiry.addFormError();
				if (!submitBtn.classList.contains('is-disabled')) {
					submitBtn.classList.add('is-disabled');
				}
			}
		});
		if (errorArry.length <= 0) {
			if (EPK.common.isSP) {
				formErrorMsg = document.querySelector('.review .error-text');
			} else {
				formErrorMsg = document.querySelector('.review-main-body .error-text');
			}
			if (formErrorMsg) {
				formErrorMsg.parentNode.removeChild(formErrorMsg);
			}
			submitBtn.classList.remove('is-disabled');
		}
	}
	if (form) {
		var reportType = form['report_type'],
		detail = form['detail'],
		mail = form['mail'],
		name = form['name'],
		agree = form['agree'];

		if (reportType) {
			reportType.addEventListener('change',function () {
				EPK.PharmacyInquiry.checkValidation();
				checkError();
			});
		}

		if (detail) {
			detail.addEventListener('change',function () {
				EPK.PharmacyInquiry.checkValidation();
				checkError();
			});
		}

		if (mail) {
			mail.addEventListener('change',function () {
				EPK.PharmacyInquiry.checkValidation();
				checkError();
			});
		}
		
		if (name) {
			name.addEventListener('change',function () {
				EPK.PharmacyInquiry.checkValidation();
				checkError();
			});
		}

		if (agree && agree.length > 0) {
			for (var i = 0; i < agree.length; i++) {
				agree[i].addEventListener('change',function () {
					EPK.PharmacyInquiry.checkValidation();
					checkError();
				});
			}
		}
	};
	
}

EPK.PharmacyInquiry.checkreportType = function (reportType) {
    var allowedValue = ['1','2','3','4','5','6'];

    if (reportType && reportType.value) {
        if (allowedValue.indexOf(reportType.value) !== -1) {
            EPK.PharmacyInquiry.ErrorFlags['report_type'] = false;
        } else {
            EPK.PharmacyInquiry.ErrorFlags['report_type'] = true;
        }
    }
};

EPK.PharmacyInquiry.checkdetail = function (detail) {

	var upperLimit = 100;
	var cleaned = detail.value.replace(/[\s　]/g, '');
	var errorArry = [];
	var requiredError = EPK.PharmacyInquiry.errorMessage('div','error-message','・必須項目です。');
	var detailParent = detail.closest('.input.textarea');
	var div =  EPK.PharmacyInquiry.errorMessage('div','error-message','');
	var errorMessage;
	
	var ul = EPK.PharmacyInquiry.errorMessage('ul','','');
		div.insertAdjacentElement('beforeEnd',ul);
	
	if (cleaned.length === 0) {
		errorArry.push(true);
		div = EPK.PharmacyInquiry.errorMessage('div','error-message','・必須項目です。');
	} else if (cleaned.length > 0 && cleaned.length > upperLimit) {
		errorArry.push(true);
		var li = EPK.PharmacyInquiry.errorMessage('li','','・100文字以内で入力してください。');
		ul.insertAdjacentElement('beforeEnd',li);
	}
	if (detail.value.indexOf('.') !== -1) {
		errorArry.push(true);
		var li = EPK.PharmacyInquiry.errorMessage('li','','・ドット「.」は入力できません。');
		ul.insertAdjacentElement('beforeEnd',li);
	}

	if (errorArry.length) {
		EPK.PharmacyInquiry.ErrorFlags['detail'] = true;
		errorMessage = document.querySelector('.input.textarea .error-message');
		if (errorMessage) {
			errorMessage.parentNode.removeChild(errorMessage);
		}
		if (detailParent) detailParent.insertAdjacentElement('beforeEnd',div)
		if (!detail.classList.contains('form-error') 
			&& !detailParent.classList.contains('error')) {
			detail.classList.add('form-error');
			detailParent.classList.add('error');
		}

	} else {
		EPK.PharmacyInquiry.ErrorFlags['detail'] = false;
		detail.classList.remove('form-error');
		detailParent.classList.remove('error');
		errorMessage = document.querySelector('.input.textarea .error-message');
		if (errorMessage) {
			errorMessage.parentNode.removeChild(errorMessage);
		}
	}
};

EPK.PharmacyInquiry.checkMail = function (mail) {
	var pattern = /^([!-9;-?A-~]+)@([!-9;-?A-~]+)\.([!-9;-?A-~]+)$/;
	var lowerLimit = 1;
	var errorMessage;
	var errorElem;
	var mailParent = mail.closest('.input.text');
	if (mail.value < lowerLimit) {
		EPK.PharmacyInquiry.ErrorFlags['mail'] = false;
	}else if (pattern.test(mail.value)) {
		EPK.PharmacyInquiry.ErrorFlags['mail'] = false;
	} else {
		EPK.PharmacyInquiry.ErrorFlags['mail'] = true;
		errorMessage = EPK.PharmacyInquiry.errorMessage('div','error-message','・形式が不正です。');
	}

	errorElem = mailParent.querySelector('.error-message');
	if (EPK.PharmacyInquiry.ErrorFlags['mail']) {
		if (mailParent && !mailParent.classList.contains('error')
		&& !mail.classList.contains('form-error')) {
			mailParent.classList.add('error');
			mail.classList.add('form-error');
		}
		if (errorElem) {
			errorElem.parentNode.removeChild(errorElem);
		}
		errorElem = mailParent.querySelector('.error-message');
		if (!errorElem) {
			mailParent.insertAdjacentElement('beforeEnd',errorMessage);
		}
	} else {
		if (errorElem) {
			errorElem.parentNode.removeChild(errorElem);
		}
		mailParent.classList.remove('error');
		mail.classList.remove('form-error');
	}
};

EPK.PharmacyInquiry.checkName = function (name) {
	var lowerLimit = 2;
	var upperLimit = 20;
	var nameParent = name.closest('.input.text');
	var errorElem;
	var errorMessage;
	if (name.value.length === 0) {
		EPK.PharmacyInquiry.ErrorFlags['name'] = false;
	} else if (lowerLimit > name.value.length || upperLimit < name.value.length) {
		EPK.PharmacyInquiry.ErrorFlags['name'] = true;
		errorMessage = EPK.PharmacyInquiry.errorMessage('div','error-message','・2文字以上、20文字以下で入力してください。');
	} else {
		EPK.PharmacyInquiry.ErrorFlags['name'] = false;
	}

	errorElem = nameParent.querySelector('.error-message');
	if (EPK.PharmacyInquiry.ErrorFlags['name']) {
		if (!errorElem) {
			nameParent.insertAdjacentElement('beforeEnd',errorMessage);
		}
		if (nameParent && !nameParent.classList.contains('error')
		&& !name.classList.contains('form-error')) {
			nameParent.classList.add('error');
			name.classList.add('form-error');
		}
	} else {
		if (errorElem) {
			errorElem.parentNode.removeChild(errorElem);
		}
		nameParent.classList.remove('error');
		name.classList.remove('form-error');
	}
};

EPK.PharmacyInquiry.checkAgree = function (agree) {
	var agreeChecked = false;
	var allowedValue = ['1'];
	var errorMessage = EPK.PharmacyInquiry.errorMessage('div','error-message','・必ずチェックしてください。');
	var agreeParent;
	var errorElem;


	for (var i = 0; i < agree.length; i++) {
		agreeParent = agree[i].closest('div');
		if (agree[i].checked && allowedValue.indexOf(agree[i].value) !== -1) {
			agreeChecked = true;
		}
	}

	errorElem = agreeParent.querySelector('.error-message');
	if (!agreeChecked) {
		EPK.PharmacyInquiry.ErrorFlags['agree'] = true;
		if (!errorElem) {
			agreeParent.insertAdjacentElement('beforeEnd',errorMessage);
		}
		if (agreeParent && !agreeParent.classList.contains('error')) {
			agreeParent.classList.add('error');
			for (var i = 0; i < agree.length; i++) {
				if (!agree[i].classList.contains('form-error')) {
					agree[i].classList.add('form-error');
				}
			}
		}
	} else {
		EPK.PharmacyInquiry.ErrorFlags['agree'] = false;
		if (errorElem) {
			errorElem.parentNode.removeChild(errorElem);
		}
		agreeParent.classList.remove('error');
		for (var i = 0; i < agree.length; i++) {
			agree[i].classList.remove('form-error');
		}
	}
};

EPK.PharmacyInquiry.errorMessage = function (tag,className,message) {
	var errorMessage
	if (tag) {
		errorMessage = document.createElement(tag);
	}
	if (errorMessage && className) {
		errorMessage.classList.add(className);
	}
	if (errorMessage && message) {
		errorMessage.textContent = message;
		
	}
	return errorMessage
};

EPK.PharmacyInquiry.addFormError = function () {
	var reviewBox;
	var formError;
	var formErrorMsg = EPK.PharmacyInquiry.errorMessage('div','error-message-top','・正しく入力されていない項目があります。');

	if (!EPK.common.isSP) {
		reviewBox = document.querySelector('.inquiry-contact-box');
		formError = document.querySelector('.inquiry-contact-box .error-message-top');
		if (reviewBox && !formError) {
			reviewBox.insertAdjacentElement('afterBegin',formErrorMsg)
		}
	}
};

window.addEventListener('DOMContentLoaded',function () {
	/** #27605 */
	if (EPK.common.action === 'index' || EPK.common.action === 'entry') {
		var submitBtn;
		if (EPK.common.isSP) {
			submitBtn = document.querySelector('.terms .submit-button');
		} else {
			submitBtn = document.querySelector('.contact-form-submit-box .contact-form-submit');
		}
		if (submitBtn) {
			submitBtn.addEventListener('click',function (e) {
				e.preventDefault();
				var errorArry = [];
				EPK.PharmacyInquiry.checkValidation();
				Object.keys(EPK.PharmacyInquiry.ErrorFlags).forEach(function(key) {

					if (EPK.PharmacyInquiry.ErrorFlags[key]) {
						errorArry.push(EPK.PharmacyInquiry.ErrorFlags[key]);
						EPK.PharmacyInquiry.addFormError();
						if (!submitBtn.classList.contains('is-disabled')) {
							submitBtn.classList.add('is-disabled');
						}
						return window.scrollTo(0, 0);
					}
				});
				if (errorArry.length <= 0) {
					if (!EPK.common.isSP) {
						formErrorMsg = document.querySelector('.inquiry-contact-box .error-message-top');
					}
					if (formErrorMsg) {
						formErrorMsg.parentNode.removeChild(formErrorMsg);
					}
					document.forms[0].submit();
				}
			});
			EPK.PharmacyInquiry.changeValidation();
		}
	}
})

$(function () {
    var EPK = EPK || {};
    EPK.popupArray = EPK.callcenterPopupArray || [];
    EPK.popupArray.push('#modal-btn-1');

    EPK.accordionTabsArray = EPK.accordionTabsArray || [];
    EPK.accordionTabsArray.push("expand-menu");

    if (EPK.popupArray instanceof Array){
        EPK.popupArray.forEach(function(btnId){
            $(btnId).magnificPopup({
                "type": 'inline',
                "preloader": false,
                'showCloseBtn': false,
                'removalDelay': 400,
                'mainClass': 'mfp-fade',
                'overflowY': 'scroll'
            });
            $('.btn-closeModal').click(
                function(e){
                    e.preventDefault();
                    $.magnificPopup.close();
                }
            );
        });
    }



    var $request_category_master_detail_id = $('#request-category-master-detail-id');
    var original = $request_category_master_detail_id.html();

    $('#request-category-master-id').change(function() {
        var val1 = $(this).val();
        $request_category_master_detail_id.html(original).find('option').each(function() {
            var val2 = $(this).data('val');
            if (val1 != val2) {
                $(this).not(':first-child').remove();
            }
        });
        if ($(this).val() == "") {
            $request_category_master_detail_id.attr('disabled', 'disabled');
        } else {
            $request_category_master_detail_id.removeAttr('disabled');
        }
    });

    if ($('#request-category-master-id').val() > 0) {
        var val1 = $('#request-category-master-id').val();
        $request_category_master_detail_id.html(original).find('option').each(function() {
            var val2 = $(this).data('val');
            if (val1 != val2) {
                $(this).not(':first-child').remove();
            }
        });
        $request_category_master_detail_id.removeAttr('disabled');
    }


    // 必須項目入力
    var requirdInput = $('.contact-article select, .contact-article input:not([type="hidden"]), .contact-article textarea');

    function requirdForm() {
        var flag = true;
        //必須項目をひとつずつチェック
        $(requirdInput).each(function (e) {
          if ($(requirdInput).eq(e).val() === "") {
            flag = false;
          }
        });

        // チェックボックス確認
        if(!$('#agree').prop('checked')) {
            flag = false;
        }

        // ボタン状態変更
        if (flag) {
          $('.agreement input[type="submit"]').prop("disabled", false);
        }
        else {
          $('.agreement input[type="submit"]').prop("disabled", true);
        }
    }
    
    // 入力確認
    requirdForm();

    $(requirdInput).change(function () {
        requirdForm();
    });
    $('#agree').on('click', function(){
        requirdForm();
    });

});
